import { useParams } from 'react-router-dom';
import FicheLot from './FicheLot';

export default function FicheLotAuto() {
  const { id } = useParams();
  return <FicheLot lotId={id} />;
}